export default __webpack_public_path__ + "locales/lo-LA/SocialAuthWelcomeDialog.json?hash=6dd9b9ea3f11a24c7e9a7635e7053a1b";